module.exports = __webpack_public_path__ + "static/media/path04.0d322113.png";